<template>
  <div class="flex items-center justify-center">
    <div class="w-full md:max-w-[110rem] p-1 md:p-5">
      <slot />
    </div>
  </div>
</template>
